<template>
  <div>
    <div class="vm-search">
      <el-select v-model="filter.tax" style="width: 100px">
        <el-option value="含税" label="含税"/>
        <el-option value="不含税" label="不含税"/>
      </el-select>
      <el-date-picker
          v-model="filter.beginTime"
          value-format="yyyy-MM-dd"
          type="date"
          style="width: 150px"
          placeholder="选择开始日期"/>
      <el-button
          :loading="status==='loading'"
          type="primary"
          size="mini"
          style="height: 26px; padding: 0 10px; margin-left: 10px;"
          @click="getList">
        查询
      </el-button>
      <el-button :loading="downLoadLoading" type="primary" size="mini" @click="downLoadFile">下载</el-button>
    </div>
    <el-table
        ref="table"
        v-loading="status==='loading'"
        :data="tableData"
        style="width: 100%"
        row-key="pkId"
        height="calc(100vh - 20vh)"
        :tree-props="{children: 'children'}">
      <template slot="empty">
        <i v-if="status==='loading'" class="el-icon-loading" style="font-size: 18px"/>
        <el-button v-else-if="status==='error'" @click="getList">加载失败，点击重新获取</el-button>
        <div v-else-if="status==='empty'">暂无数据</div>
      </template>
      <el-table-column prop="departmentName" align="center" label="区域">
        <template slot-scope="scope">
          <span v-if="scope.row.employeeName">{{scope.row.employeeName}}</span>
          <span v-else>{{scope.row.departmentName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalMoneyOfDay" align="center" label="日销售额"/>
      <el-table-column prop="deliveryTotalMoneyOfDay" align="center" label="日发货额"/>
      <el-table-column prop="totalMoneyOfMonth" align="center" label="本月至今销售额"/>
<!--      <el-table-column prop="salesTargetOfMonth" align="center" label="本月指标"/>-->
<!--      <el-table-column width="130" prop="salesTargetCompletionPercentageOfMonth" align="center" label="本月指标完成百分比"/>-->
      <el-table-column prop="deliveryTotalMoneyOfMonth" align="center" label="本月至今发货额"/>
      <el-table-column prop="totalMoneyOfYear" align="center" label="本年至今销售额"/>
<!--      <el-table-column prop="salesTargetOfYear" align="center" label="本年指标"/>-->
<!--      <el-table-column width="140" prop="salesTargetCompletionPercentageOfYear" align="center" label="本年指标完成百分比"/>-->
      <el-table-column prop="deliveryTotalMoneyOfYear" align="center" label="本年至今发货额"/>
    </el-table>
  </div>

</template>

<script>
  import dateUtil from "@/util/dateUtil";
  import loginUtil from "../../util/loginUtil";

  export default {
    name:"RegionalSummary",
    data() {
      return {
        status: "loading",
        downLoadLoading:false,
        tableData: [],
        filter: {
          beginTime: dateUtil.format(new Date(), "yyyy-MM-dd"),
          tax:"含税",
        },
      };
    },
    mounted() {
      // let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      // if (flag) {
      //   let userInfo = JSON.parse(window.userInfo.getUserInfo());
      //   if (userInfo.userName!=="") {
      //     loginUtil.login(userInfo);
      //   }
      // }
      this.getList();
    },
    methods:{
      getList() {
        let params = {
          "beginTime": this.filter.beginTime,
        };
        this.status = "loading";
        this.$http.get("basic", "sd/so/getSalesSummaryList", this.filter).then(resp => {
          this.tableData = resp;
          if (resp.length === 0) {
            this.status = "empty";
          } else {
            this.status = "finish";
          }
        }).catch(() => {
          this.status = "error";
        });
      },

      downLoadFile() {
        this.downloadLoading = true;
        this.$http
          .postForFile("basic", "sd/so/exportSalesSummaryList", this.tableData)
          .then((resp) => {
            let blob = new Blob([resp.data]);
            let fileName = decodeURI(resp.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.downloadLoading = false;
          })
          .catch(() => {
            this.downloadLoading = false;
          });
      },
    },
  };
</script>

<style scoped>
  .vm-search {
    margin: 10px;
  }
</style>